const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;

/**
 * @description React Query 캐싱 시간을 위한 상수
 */
export const QUERY_TIME = {
  ZERO_SECONDS: 0 * SECOND,
  SEVEN_SECONDS: 7 * SECOND,
  THIRTY_SECONDS: 30 * SECOND,

  ONE_MINUTE: 1 * MINUTE,
  FIVE_MINUTES: 5 * MINUTE,
  TEN_MINUTES: 10 * MINUTE,

  ONE_HOUR: 1 * HOUR,

  STALE_TIME_INFINITE: Infinity,
  GC_TIME_INFINITE: Infinity,
} as const;
